import _get from 'lodash/get';
import { a as _objectSpread } from '../chunk-ad6ad343.js';
import { lighten, tint, readableColor, shade, darken } from 'polished';

var generateTextVariants = function generateTextVariants(textColor) {
  return {
    text100: lighten(0.2, textColor),
    text200: lighten(0.15, textColor),
    text300: lighten(0.1, textColor),
    text400: lighten(0.05, textColor),
    text: textColor,
    textTint: tint(0.8, textColor),
    textInverted: readableColor(textColor),
    textTintInverted: shade(0.3, textColor)
  };
};

var generateColorVariants = function generateColorVariants(_ref) {
  var _objectSpread2;

  var color = _ref.color,
      paletteKey = _ref.paletteKey,
      paletteOverrides = _ref.paletteOverrides;
  return _objectSpread((_objectSpread2 = {}, _objectSpread2[paletteKey + "100"] = tint(0.7, color), _objectSpread2[paletteKey + "200"] = tint(0.5, color), _objectSpread2[paletteKey + "300"] = tint(0.3, color), _objectSpread2[paletteKey + "400"] = tint(0.1, color), _objectSpread2[paletteKey] = color, _objectSpread2[paletteKey + "500"] = color, _objectSpread2[paletteKey + "600"] = shade(0.1, color), _objectSpread2[paletteKey + "700"] = shade(0.3, color), _objectSpread2[paletteKey + "800"] = shade(0.5, color), _objectSpread2[paletteKey + "900"] = shade(0.7, color), _objectSpread2[paletteKey + "Tint"] = tint(0.9, color), _objectSpread2[paletteKey + "Inverted"] = readableColor(color), _objectSpread2[paletteKey + "TintInverted"] = shade(0.5, color), _objectSpread2), paletteOverrides ? paletteOverrides({
    color: color
  }) : {});
};

var defaultPalette = {
  text: '#435a6f',
  primary: '#444bc9',
  secondary: '#793fb2',
  info: '#35709e',
  success: '#2c8453',
  danger: '#c9444d',
  warning: '#f2a100'
};

var _defaultPalette = function _defaultPalette(overrides) {
  return _objectSpread({}, generateTextVariants(_get(overrides, 'palette.text') || defaultPalette.text), {
    black: 'black',
    black500: 'black',
    white: 'white',
    white500: 'white',
    white600: darken(0.03, 'white'),
    white700: darken(0.05, 'white'),
    white800: darken(0.1, 'white'),
    white900: darken(0.15, 'white'),
    gray100: lighten(0.2, 'gray'),
    gray200: lighten(0.15, 'gray'),
    gray300: lighten(0.1, 'gray'),
    gray400: lighten(0.05, 'gray'),
    gray: 'gray',
    gray500: 'gray',
    gray600: darken(0.05, 'gray'),
    gray700: darken(0.1, 'gray'),
    gray800: darken(0.15, 'gray'),
    gray900: darken(0.2, 'gray'),
    default: darken(0.01, 'white'),
    defaultInverted: '#435a6f'
  }, generateColorVariants({
    paletteKey: 'primary',
    color: _get(overrides, "palette.primary") || defaultPalette.primary
  }), generateColorVariants({
    paletteKey: 'secondary',
    color: _get(overrides, "palette.secondary") || defaultPalette.secondary
  }), generateColorVariants({
    paletteKey: 'info',
    color: _get(overrides, "palette.info") || defaultPalette.info
  }), generateColorVariants({
    paletteKey: 'success',
    color: _get(overrides, "palette.success") || defaultPalette.success
  }), generateColorVariants({
    paletteKey: 'danger',
    color: _get(overrides, "palette.danger") || defaultPalette.danger
  }), generateColorVariants({
    paletteKey: 'warning',
    color: _get(overrides, "palette.warning") || defaultPalette.warning,
    paletteOverrides: function paletteOverrides(_ref) {
      var color = _ref.color;
      return {
        warningTintInverted: shade(0.7, color)
      };
    }
  }), _get(overrides, 'palette', {}));
};

export default _defaultPalette;